{
  "de": {
    "filteredList": {
      "actions": {
        "showFilter": "Filter anzeigen",
        "hideFilter": "Filter ausblenden"
      },
      "selected": "Ausgewählte Filter",
      "remove": "%{filter} entfernen",
      "more": "+%{count} weitere",
      "groups": {
        "ship": "Schiff",
        "capacity": "Kapazität & Abmessungen",
        "weapons": "Waffen",
        "price": "Preis",
        "ownership": "Besitz"
      }
    }
  }
}
